<template>
  <div>
    <div class="wrapper">
      <canvas id="signature-pad"></canvas>
    </div>
    <div class="mt-3 d-flex justify-content-end">
      <button v-on:click="clear" class="btn btn-outline-danger mr-3">
        Limpiar
      </button>
      <button v-on:click="save" class="btn btn-success">Guardar</button>
    </div>
  </div>
</template>

<style>
#signature-pad {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.582);
  width: 100%;
  height: 300px;
  border: 1px dashed gray;
}
</style>

<script>
import SignaturePad from "signature_pad";

export default {
  data: function () {
    return {
      canvas: Object,
      signaturePad: Object,
      isSigned: false,
    };
  },
  methods: {
    render() {
      this.canvas = document.querySelector("#signature-pad");
      this.signaturePad = new SignaturePad(this.canvas, {
        backgroundColor: "rgba(255, 255, 255, 0)",
        penColor: "rgb(99, 98, 98)",
        maxWidth: 2,
      });
      this.resize();
    },
    resize() {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      this.canvas.width = this.canvas.offsetWidth * ratio;
      this.canvas.height = this.canvas.offsetHeight * ratio;
      this.canvas.getContext("2d").scale(ratio, ratio);
      this.signaturePad.clear();
    },
    clear() {
      this.signaturePad.clear();
    },
    save() {
      const dataURL = this.signaturePad.toDataURL();

      if (
        navigator.userAgent.indexOf("Safari") > -1 &&
        navigator.userAgent.indexOf("Chrome") === -1
      ) {
        window.open(dataURL);
      } else {
        var blob = this.dataURLToBlob(dataURL);
        var url = window.URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.style = "display: none";
        a.href = url;
        a.download = "Latino_firma";

        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
      }
    },
    dataURLToBlob(dataURL) {
      var parts = dataURL.split(";base64,");
      var contentType = parts[0].split(":")[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;
      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    },
  },

  mounted() {
    this.render(); const _this = this;
    window.addEventListener("resize", function(){
        _this.resize();
    });
  },
};
</script>